import gsap from "gsap";

const multiplied_word = () => {
    const $servicesHeading = $('.section.services h2');
    const $originalSpan = $servicesHeading.find('.multiplied-word').first();
    const $serviceLines = [];

    for (let i = 0; i < 5; i++) {
        const $newSpan = $originalSpan.clone();
        $servicesHeading.append($newSpan);
        $serviceLines.push($newSpan);
    }

    function handleIntersection(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const timeline = gsap.timeline();

                $serviceLines.forEach((line, index) => {
                    timeline.to(line, {
                        height: [40, 60, 100, 140, 300][index],
                        opacity: 1,
                        duration: 1,
                        ease: 'power2.out'
                    }, index * 0.2);
                });

                observer.unobserve(entry.target);
            }
        });
    }

    const observer = new IntersectionObserver(handleIntersection, {
        threshold: 0.2 
    });

    observer.observe($servicesHeading[0]);
};

export default multiplied_word;

